/* RESPONSIBLE TEAM: team-inbox */
import Model, { attr, hasMany } from '@ember-data/model';

export default class IntercomPagesProfileModel extends Model {
  @attr('string') assetUrl;
  @attr('string') publicUrl;
  @hasMany('intercom-sub-page', { async: false }) subPages;
}
